import React from 'react';
import className from 'classnames';
import { noop } from 'lodash';
import { Container } from '@fiverr-private/layout_components';
import SearchForm from '../../components/SearchForm';
import AiPillSearchPanel from './AiPillSearchPanel';
import { aiPillContainerClass, aiPillOpenClass } from './styles.ve.css';

/**
 * Renders the AI pill search bar: the pill form and, while open, the card panel.
 * Wrapped in a slot that keeps the closed pill height while the card is open,
 * so the open card overlays the page instead of pushing content down.
 * @returns {React.ReactElement}
 */
export const renderAiPill = ({
    isOpen,
    closedHeight,
    containerRef,
    formInputRef,
    preventCloseAction,
    onFocus,
    open,
    close,
    formToQueryParams,
    submitOnEnter,
    theme,
    abTests,
    dimBackgroundEnabled,
    submitButtonType,
    submitButtonText,
    hideClearButton,
    subCategoryId,
}) => {
    const slotHeight = isOpen && closedHeight ? `${closedHeight}px` : undefined;
    const searchBarClass = className('search-bar-package', 'search_bar-package', aiPillContainerClass, {
        [aiPillOpenClass]: isOpen,
    });

    return (
        <Container height={slotHeight} position="relative">
            <Container
                className={searchBarClass}
                display="flex"
                flexDirection="column"
                ref={(el) => {
                    preventCloseAction(el);
                    containerRef.current = el;
                }}
            >
                <SearchForm
                    onFocus={onFocus}
                    isOpen={isOpen}
                    formInputRef={formInputRef}
                    onKeyDown={open}
                    onSubmit={close}
                    close={close}
                    formToQueryParams={formToQueryParams}
                    submitOnEnter={submitOnEnter}
                    theme={theme}
                    inSearchBarAnimationExp={abTests.inSearchBarAnimationExp}
                    dimBackgroundEnabled={dimBackgroundEnabled}
                    containerRef={containerRef}
                    submitButtonType={submitButtonType}
                    // `SearchForm` calls it on focus unconditionally; the AI pill has no routing state.
                    setIsRoutingSearchBarOpen={noop}
                    submitButtonText={submitButtonText}
                    hideClearButton={hideClearButton}
                    subCategoryId={subCategoryId}
                />
                {isOpen && <AiPillSearchPanel />}
            </Container>
        </Container>
    );
};
